import { render, staticRenderFns } from "./UserMedia.vue?vue&type=template&id=025f5fc4&scoped=true"
import script from "./UserMedia.vue?vue&type=script&lang=js"
export * from "./UserMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f5fc4",
  null
  
)

export default component.exports